import { useState,useRef } from "react";
import { useLocation } from "react-router-dom";

export default function SecurePaymentAuthenticationlXml() {
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = useState(1);
  const [activeTabSecond, setActiveTabSecond] = useState(3);
  const [activeTabThird, setActiveTabThird] = useState(5);
  const [activeTabFourth, setActiveTabFourth] = useState(7);
  const copyBodyRef = useRef(null);
  const copyBodyRef1 = useRef(null);
  const copyBodyRef2 = useRef(null);
  const copyBodyRef3 = useRef(null);
  const [copied, setCopied] = useState(false);


  const handleCopy = (ref) => {
    const text = ref.current.innerText;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); 
    });
  };

const formHtml = `
<form id="formCReq" name="formCReq" action="https://acstest.libertybank.ge" method="post">
              <input type="hidden" id="creq" name="creq" value="
eyJtZXNzYWdlVHlwZSI6IkNSZXEiLCJtZXNzYWdlVmVyc2lvbiI6IjIuMi4wIiwiYWNzVHJhbnNJRCI6ImE2ZTAwZTk
wLTRjODUtNGZhNS1hYzNkLWU5NWQ4YjdmZjU1ZSIsInRocmVlRFNTZXJ2ZXJUcmFuc0lEIjoiNTc2ODUzMzEtNj
A5NS00ZDE3LTg2MzctNzU2YjJjMDhjY2QzIn0=" />
              </form> `;
  return (
    <>
      <div className="doc-content">
        <h3 className="text-left pb-24 doc-title">EMV 3-D Secure Authentication without
         Redirecting to TXPG payment Page</h3>
         <p className="text-in mb-24 black">Making transaction without visiting TXPG payment page</p>
        <h4 className="pb-16 sub-title flex-items-center">
           <span className="xml-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21.477"
              height="25.5"
              viewBox="0 0 21.477 25.5"
            >
              <g
                id="Type_Code_-_XML_Style_Default"
                data-name="Type= Code - XML, Style=Default"
                transform="translate(-1)"
              >
                <path
                  id="Path_6092"
                  data-name="Path 6092"
                  d="M23.516,5.448V22.724A2.026,2.026,0,0,1,21.49,24.75H7.776A2.026,2.026,0,0,1,5.75,22.724V2.776A2.026,2.026,0,0,1,7.776.75H18.4Z"
                  transform="translate(-1.789)"
                  fill="none"
                  stroke="#d0d5dd"
                  stroke-width="1.5"
                />
                <path
                  id="Path_6093"
                  data-name="Path 6093"
                  d="M24.623,1h0Zm5.3,5.922H25.247A1.247,1.247,0,0,1,24,5.675h5.922Zm-4.675,0A1.247,1.247,0,0,1,24,5.675V1h1.247V6.922ZM29.922,1V1Z"
                  transform="translate(-8.662 -0.094)"
                  fill="#d0d5dd"
                />
                <rect
                  id="Rectangle_2270"
                  data-name="Rectangle 2270"
                  width="16.208"
                  height="8.104"
                  rx="2"
                  transform="translate(1 12.75)"
                  fill="#2d3282"
                />
                <path
                  id="Path_6094"
                  data-name="Path 6094"
                  d="M6.611,27.356l-.891-1.34-.785,1.34H3.724l1.4-2.225L3.693,22.98H4.934L5.813,24.3l.773-1.322H7.795L6.4,25.187l1.446,2.169Zm6.732-4.376v4.376H12.276V24.732L11.3,27.356h-.86l-.985-2.631v2.631H8.386V22.98H9.645l1.228,3.03,1.216-3.03Zm1.833,3.553h1.4v.823H14.109V22.98h1.066Z"
                  transform="translate(-1.014 -8.372)"
                  fill="#fff"
                />
              </g>
            </svg>
          </span>
          <span className="pl-12"> XML</span>
        </h4>
        <p className="text-in mb-12 black">Creating Purchase Order</p>
        <div className="sub-link flex-items-center pb-32">
          <p className="black">Example of the request url:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6443/Exec
"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            https://libertypaytxtest.lb.ge:6443/Exec

          </a>
        </div>

         {/* Step 1: */}
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTab === 1 ? "active-tab" : "tab"}
                onClick={() => setActiveTab(1)}
              >
                Request
              </div>
              <div
                className={activeTab === 2 ? "active-tab" : "tab"}
                onClick={() => setActiveTab(2)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 1 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre ref={copyBodyRef} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="token token-line-head">?xml version="1.0" encoding="UTF-8"?</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>

                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Request</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span>CreateOrder</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Language</span>
                          <span className="punctuation">{">"}</span>
                          <span>RU</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Language</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">OrderType</span>
                          <span className="punctuation">{">"}</span>
                          <span>Purchase</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">OrderType</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Merchant</span>
                          <span className="punctuation">{">"}</span>
                          <span>IA00007A</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Merchant</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Amount</span>
                          <span className="punctuation">{">"}</span>
                          <span>1</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Amount</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                       
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Currency</span>
                          <span className="punctuation">{">"}</span>
                          <span>981</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Currency</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Description</span>
                          <span className="punctuation">{">"}</span>
                          <span>xxxxxxxx</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Description</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ApproveURL</span>
                          <span className="punctuation">{">"}</span>
                          <span>https://libertypaytxtest.lb.ge/</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ApproveURL</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CancelURL</span>
                          <span className="punctuation">{">"}</span>
                          <span>https://libertypaytxtest.lb.ge/</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CancelURL</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">DeclineURL</span>
                          <span className="punctuation">{">"}</span>
                          <span>https://libertypaytxtest.lb.ge/</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">DeclineURL</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">AddParams</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">AddParams</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Request</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                      </code> 
                    </pre>
                  </div>
                </div>
                <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">Operation</span>
                      <span>- Operation Type.</span>
                    </p>
                    <p>
                      <span className="tag">Language</span>
                      <span>- Interface language Language.</span>
                    </p>
                    <p>
                      <span className="tag">OrderType</span>
                      <span>
                        - Order Type. The financial transaction to be created. Specify the Purchase value to
perform the purchase.
                      </span>
                    </p>
                    <p>
                      <span className="tag">Merchant</span>
                      <span>- Internet shop ID.</span>
                    </p>
                    <p>
                      <span className="tag">Amount</span>
                      <span>
                        - Transaction amount in the minimum units of the transaction currency.
                      </span>
                    </p>   
                    <p>
                      <span className="tag">Currency</span>
                      <span>
                        - Transaction currency code (e.g. 981– Georgian Lari, 840 – US Dollar).
                      </span>
                    </p>   
                    <p>
                      <span className="tag">Description</span>
                      <span>
                        - - Order text description. It is displayed to the customer during payment.
                      </span>
                    </p>   
                    <p>
                      <span className="tag">ApproveURL</span>
                      <span>
                        - URL to forward the customer to if the operation is approved. If the parameter is not
                        defined, its value will be taken from the parameter of the same name specified in the merchant
                        settings.
                      </span>
                    </p>
                    <p>
                      <span className="tag">CancelURL</span>
                      <span>
                        - URL to forward the customer to if the operation is cancelled (by clicking the Cancel
                        button).
                      </span>
                    </p>
                    <p>
                      <span className="tag">DeclineURL</span>
                      <span>
                        - URL to forward the customer to if the payment operationis declined.
                      </span>
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <>
               <div className="code-ceontent">
                  <div className="code-body">
                      <pre ref={copyBodyRef} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span>CreateOrder</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Status</span>
                          <span className="punctuation">{">"}</span>
                          <span>00</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Status</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span>1809</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span>6lv5g8sv063y</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">URL</span>
                          <span className="punctuation">{">"}</span>
                          <span>https://libertypaytxtest.lb.ge/twpga</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">URL</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                      </code> 
                    </pre>
                  </div>
                </div>
                <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">Operation</span>
                      <span>- Operation Type.</span>
                    </p>
                    <p>
                      <span className="tag">Status</span>
                      <span>- Order status. 00 means no errors.</span>
                    </p>
                    <p>
                      <span className="tag">OrderID</span>
                      <span>– Order Id</span>
                    </p>
                    <p>
                      <span className="tag">SessionID</span>
                      <span>– Session Id or password.</span>
                    </p>
                    <p>
                      <span className="tag">URL</span>
                      <span>
                        - payment page url if not provided use one written
                        below.
                      </span>
                    </p>
                  </div>
                </div>
              </>
            )}{" "}
          </div>
        </div>

        {/* Next step Process3DSAuth – First: */}

         <h5 className="step-title pt-16">Next step Process3DSAuth – First</h5>
         <div className="sub-link flex-items-center pb-32">
          <p className="black">Example of the request url:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6443/Exec
"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            https://libertypaytxtest.lb.ge:6443/Exec

          </a>
        </div>
         <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTabSecond === 3 ? "active-tab" : "tab"}
                onClick={() => setActiveTabSecond(3)}
              >
                Request
              </div>
              <div
                className={activeTabSecond === 4 ? "active-tab" : "tab"}
                onClick={() => setActiveTabSecond(4)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef1)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>


          <div className="tab-content">
            {activeTabSecond === 3 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                      <pre ref={copyBodyRef1} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="token token-line-head">?xml version="1.0" encoding="UTF-8"?</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Request</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span>Process3DSAuth</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Step</span>
                          <span className="punctuation">{">"}</span>
                          <span>FIRST</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Step</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Language</span>
                          <span className="punctuation">{">"}</span>
                          <span>RU</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Language</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span>1809</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Merchant</span>
                          <span className="punctuation">{">"}</span>
                          <span>IA00007A</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Merchant</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span>6lv5g8sv063y</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PAN</span>
                          <span className="punctuation">{">"}</span>
                          <span>4125710020009128</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PAN</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PAN2</span>
                          <span className="punctuation">{">"}</span>
                          <span>4125710020009128</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PAN2</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ExpDate</span>
                          <span className="punctuation">{">"}</span>
                          <span>0326</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ExpDate</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CardHolderName</span>
                          <span className="punctuation">{">"}</span>
                          <span>Jhon Doe</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CardHolderName</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CVV2</span>
                          <span className="punctuation">{">"}</span>
                          <span>582</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CVV2</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">AReqDetails</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">deviceChannel</span>
                          <span className="punctuation">{">"}</span>
                          
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">deviceChannel</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">AReqDetails</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Request</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                      </code> 
                    </pre>
                  </div>
                </div>
                <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">Operation</span>
                      <span>- Operation Type.</span>
                    </p>
                    <p>
                      <span className="tag">Step</span>
                      <span>- Step Type.</span>
                    </p>
                    <p>
                      <span className="tag">Language</span>
                      <span>- Interface language Language</span>
                    </p>
                    
                    <p>
                      <span className="tag">OrderID</span>
                      <span>– Order Id</span>
                    </p>
                    <p>
                      <span className="tag">Merchant</span>
                      <span>– Internet shop ID.</span>
                    </p>
                    <p>
                      <span className="tag">SessionID</span>
                      <span>– Session Id or password.</span>
                    </p>
                    <p>
                      <span className="tag">PAN</span>
                      <span>
                        - Card PAN.
                      </span>
                    </p>
                    <p>
                      <span className="tag">ExpDate</span>
                      <span>
                        - Expiration Date
                      </span>
                    </p>
                    <p>
                      <span className="tag">CardHolderName</span>
                      <span>
                        - Name on the Card.
                      </span>
                    </p>
                    <p>
                      <span className="tag">CVV2</span>
                      <span>
                        - CVV.
                      </span>
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <>
               <div className="code-ceontent">
                  <div className="code-body">
                      <pre ref={copyBodyRef1} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span>Process3DSAuth</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Status</span>
                          <span className="punctuation">{">"}</span>
                          <span>00</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Status</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">NextStep</span>
                          <span className="punctuation">{">"}</span>
                          <span>AREQ</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">NextStep</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                      </code> 
                    </pre>
                  </div>
                </div>
                <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">Operation</span>
                      <span>- Operation Type.</span>
                    </p>
                    <p>
                      <span className="tag">Status</span>
                      <span>- Order status. 00 means no errors</span>
                    </p>
                    <p>
                      <span className="tag">NextStep</span>
                      <span>- Next Step Name.</span>
                    </p>
                  </div>
                </div>
              </>
            )}{" "}
          </div>
        </div>
      
        {/* Next step Process3DSAuth – AREQ: */}
        <h5 className="step-title pt-16">Next step Process3DSAuth – AREQ</h5>    
        <div className="sub-link flex-items-center pb-32">
          <p className="black">Example of the request url:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6443/Exec
"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            https://libertypaytxtest.lb.ge:6443/Exec

          </a>
        </div>    
        
         <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTabThird === 5 ? "active-tab" : "tab"}
                onClick={() => setActiveTabThird(5)}
              >
                Request
              </div>
              <div
                className={activeTabThird === 6 ? "active-tab" : "tab"}
                onClick={() => setActiveTabThird(6)}
              >
                Response
              </div>
            </div>
             <button
              className={`btn btn-copy ${copied ? "copied" : ""}`}
              onClick={() => handleCopy(copyBodyRef2)}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
               >
                <g
                  id="Organization-/-File-/-copy--file"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect
                    fill="#FFFFFF"
                    opacity="0"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                  ></rect>
                  <path
                    d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                    id="Fill"
                    fill="#fff"
                  ></path>
                </g>
              </svg>
              <span className="pl-6"> {copied ? "Copied" : "Copy"} </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTabThird === 5 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre ref={copyBodyRef2} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="token token-line-head">?xml version="1.0" encoding="UTF-8"?</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span>Process3DSAuth</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Step</span>
                          <span className="punctuation">{">"}</span>
                          <span>AREQ</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Step</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span>1809</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Merchant</span>
                          <span className="punctuation">{">"}</span>
                          <span>IA00007A</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Merchant</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span>6lv5g8sv063y</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PAN</span>
                          <span className="punctuation">{">"}</span>
                          <span>4125710020009128</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PAN</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PAN2</span>
                          <span className="punctuation">{">"}</span>
                          <span>4125710020009128</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PAN2</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ExpDate</span>
                          <span className="punctuation">{">"}</span>
                          <span>0326</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ExpDate</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CardHolderName</span>
                          <span className="punctuation">{">"}</span>
                          <span>Jhon Doe</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CardHolderName</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CVV2</span>
                          <span className="punctuation">{">"}</span>
                          <span>582</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CVV2</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">AReqDetails</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">notificationURL</span>
                          <span className="punctuation">{">"}</span>
                          <span>http://your_URL</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">notificationURL</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">messageCategory</span>
                          <span className="punctuation">{">"}</span>
                          <span>01</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">messageCategory</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">browserAcceptHeader</span>
                          <span className="punctuation">{">"}</span>
                          <span>application/json,application/jose;charset=utf-8</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">browserAcceptHeader</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">browserJavaEnabled</span>
                          <span className="punctuation">{">"}</span>
                          <span>false</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">browserJavaEnabled</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">browserJavascriptEnabled</span>
                          <span className="punctuation">{">"}</span>
                          <span>true</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">browserJavascriptEnabled</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">browserLanguage</span>
                          <span className="punctuation">{">"}</span>
                          <span>en-US</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">browserLanguage</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">browserColorDepth</span>
                          <span className="punctuation">{">"}</span>
                          <span>24</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">browserColorDepth</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">browserScreenHeight</span>
                          <span className="punctuation">{">"}</span>
                          <span>768</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">browserScreenHeight</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">browserScreenWidth</span>
                          <span className="punctuation">{">"}</span>
                          <span>1024</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">browserScreenWidth</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">browserTZ</span>
                          <span className="punctuation">{">"}</span>
                          <span>-240</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">browserTZ</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">browserUserAgent</span>
                          <span className="punctuation">{">"}</span>
                          <span>
                            Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko)
                            Chrome/91.0.4472.101 Safari/537.36 Edg/91.0.864.48
                          </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">browserUserAgent</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">threeRIInd</span>
                          <span className="punctuation">{">"}</span>
                          <span>05</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">threeRIInd</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">threeDSCompInd</span>
                          <span className="punctuation">{">"}</span>
                          <span>U</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">threeDSCompInd</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">threeDSRequestorAuthenticationInd</span>
                          <span className="punctuation">{">"}</span>
                          <span>01</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">threeDSRequestorAuthenticationInd</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">threeDSRequestorChallengeInd</span>
                          <span className="punctuation">{">"}</span>
                          <span>03</span>
                         <span className="punctuation">{"</"}</span>
                          <span className="property ">threeDSRequestorChallengeInd</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">transType</span>
                          <span className="punctuation">{">"}</span>
                          <span>01</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">transType</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">deviceChannel</span>
                          <span className="punctuation">{">"}</span>
                          <span>02</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">deviceChannel</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">AReqDetails</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                      </code> 
                    </pre>
                  </div>
                </div>
                <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">Operation</span>
                      <span>- Operation Type.</span>
                    </p>
                    <p>
                      <span className="tag">Step</span>
                      <span>- Step Type.</span>
                    </p>
                    <p>
                      <span className="tag">OrderID</span>
                      <span>
                        - Order Id.
                      </span>
                    </p>
                    <p>
                      <span className="tag">Merchant</span>
                      <span>- Internet shop ID.</span>
                    </p>
                    <p>
                      <span className="tag">SessionID</span>
                      <span>
                        - Session Id or password.
                      </span>
                    </p>   
                    <p>
                      <span className="tag">PAN</span>
                      <span>
                        - Card PAN.
                      </span>
                    </p>   
                    <p>
                      <span className="tag">ExpDate</span>
                      <span>
                        - Expiration Date
                      </span>
                    </p>   
                    <p>
                      <span className="tag">CardHolderName</span>
                      <span>
                        - Name on the Card.
                      </span>
                    </p>
                    <p>
                      <span className="tag">CVV2</span>
                      <span>
                        - CVV
                      </span>
                    </p>
                    <p>
                      <span className="tag">AreqDetails</span>
                      <span>
                        - Additional Details including browser Data and 3DS settings…
                      </span>
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <>
               <div className="code-ceontent">
                  <div className="code-body">
                      <pre ref={copyBodyRef2} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span>Process3DSAuth</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Status</span>
                          <span className="punctuation">{">"}</span>
                          <span>00</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Status</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">NextStep</span>
                          <span className="punctuation">{">"}</span>
                          <span>CRES</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">NextStep</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Refinement</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">RefinementType</span>
                          <span className="punctuation">{">"}</span>
                          <span>CREQ</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">RefinementType</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">AcsURL</span>
                          <span className="punctuation">{">"}</span>
                          <span>https://acstest.libertybank.ge</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">AcsURL</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CReq</span>
                          <span className="punctuation">{">"}</span>
                          <span>eyJtZXNzYWdlVHlwZSI6IkNSZXEiLCJtZXNzYWdlVmVyc2lvbiI6IjIuMi4wIiwiYWNzVHJhbnNJRCI6ImE2ZT
AwZTkwLTRjODUtNGZhNS1hYzNkLWU5NWQ4YjdmZjU1ZSIsInRocmVlRFNTZXJ2ZXJUcmFuc0lEIjoiNTc2ODUz
MzEtNjA5NS00ZDE3LTg2MzctNzU2YjJjMDhjY2QzIn0=</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CReq</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                       
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Refinement</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ARes</span>
                          <span className="punctuation">{">"}</span>
                          <span>{JSON.stringify(
                                          {
                                            threeDSServerTransID: "57685331-6095-4d17-8637-756b2c08ccd3",
                                            acsTransID: "a6e00e90-4c85-4fa5-ac3d-e95d8b7ff55e",
                                            dsTransID: "46ba2166-2885-48f6-9c32-e796a3bae717",
                                            messageType: "ARes",
                                            messageVersion: "2.2.0",
                                            messageExtension: [
                                              {
                                                name: "MesExt1",
                                                id: "ID1",
                                                criticalityIndicator: false,
                                                data: { valueOne: "value" },
                                              },
                                            ],
                                            dsReferenceNumber: "DSRefNum1",
                                            acsReferenceNumber: "3DS_LOA_ACS_COPL_020200_00327",
                                            acsChallengeMandated: "N",
                                            acsOperatorID: "10055116",
                                            acsURL: "https://acstest.libertybank.ge",
                                            authenticationType: "02",
                                            transStatus: "C",
                                          },
                                null,
                                2
                              )}</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ARes</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                       
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                      </code> 
                    </pre>
                  </div>
                </div>
                <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">Operation</span>
                      <span>- Operation Type.</span>
                    </p>
                    <p>
                      <span className="tag">Status</span>
                      <span>- Order status. 00 means no errors.</span>
                    </p>
                    <p>
                      <span className="tag">NextStep</span>
                      <span>- Next Step Name.</span>
                    </p>
                    
                    <p>
                      <span className="tag">AcsURL</span>
                      <span>– URL to 3DS page.</span>
                    </p>
                    <p>
                      <span className="tag">CReq</span>
                      <span>– Creq hashed string required for 3DS.</span>
                    </p>
                    <p>
                      <span className="tag">Ares</span>
                      <span>– additional Ares data…</span>
                    </p>
                    
                  </div>
                </div>
              </>
            )}{" "}

            <div className="other-hint" style={{paddingTop:'0'}}>
            <p className="pb-12">Next step - Merchants opens Iframe in clients browser and sends POST request with creq inside form</p>
            <p className="pt-12 ">Form example:
             <span className="link">  {formHtml}</span> </p>
              <p>After that ACS will open 3d authorization page iside Iframe.
              Client enters OTP, then ACS sends POST response to the notificationURL which we sent in Areq step: Inside
              that POST response there will be cres which you need for further steps.</p>
          </div>
          </div>
        </div>



       {/* Example: */}
        <div className="sub-link  pb-12" style={{flexDirection:'column',alignItems : 'start'}}>
          <p className="black">Example:</p>
          <span>cres = eyJ0aHJlZURTU2VydmVyVHJhbnNJRCI6ImNiYTkyYTRiLWRmOTQtNDhkMC04NGY3LTlmYjE2ZTE3MTVk
NCIsImFjc1RyYW5zSUQiOiJjYWYxNTAxMi1iMjI2LTRiZDQtYTIyZC0wMzcxMjA3Y2IyMWIiLCJtZXNzYWdlVHlwZ
SI6IkNSZXMiLCJtZXNzYWdlVmVyc2lvbiI6IjIuMS4wIiwidHJhbnNTdGF0dXMiOiJZIn0</span>
        </div>
     
      <div className="sub-link  pb-12" style={{flexDirection:'column',alignItems : 'start'}}>
        <p className="black">cres must be captured by Merchant and transferred to TXPG as a parameter.</p>
      </div>
      <div className="sub-link flex-items-center pb-32">
          <p className="black">Example of the request url:</p>
          <a
            href="https://libertypaytxtest.lb.ge:6443/Exec
"
            target="_blank"
            className="link fnt-14 underline pl-8"
          >
            https://libertypaytxtest.lb.ge:6443/Exec
          </a>
        </div>

        <div className="other-hint" style={{paddingTop:'0'}}>
                  <p className="pb-12">
                    TXPG verifies the signature of the received PARes and the 3-D Secure authentication result. If the order
payment is allowed according to the TXPG rules, TXPG sends the transaction of the respective type to the
authorization system. Depending on the authorization system response, TXPG assigns the APPROVED/
DECLINED status to the order.
                  </p>
                  <p className="pb-12">TXPG sends the operation execution result and XMLOut in the response to the ProcessPARes operation. </p>
                  <p>TXPG response format:</p>
                </div>
        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTabFourth === 7 ? "active-tab" : "tab"}
                onClick={() => setActiveTabFourth(7)}
              >
                Request
              </div>
              <div
                className={activeTabFourth === 8 ? "active-tab" : "tab"}
                onClick={() => setActiveTabFourth(8)}
              >
                Response
              </div>
            </div>
            <button className={`btn btn-copy ${copied ?'copied':''}`} onClick={() => handleCopy(copyBodyRef3)}>
              <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Organization / File / copy--file</title>
                  <g
                    id="Organization-/-File-/-copy--file"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect
                      fill="#FFFFFF"
                      opacity="0"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    ></rect>
                    <path
                      d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                      id="Fill"
                      fill="#fff"
                    ></path>
                  </g>
                </svg>
                
             <span>  {copied ? "Copied" : "Copy"}  </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTabFourth === 7 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre ref={copyBodyRef3} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="token token-line-head">?xml version="1.0" encoding="UTF-8"?</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>

                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Request</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span>Process3DSAuth</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Step</span>
                          <span className="punctuation">{">"}</span>
                          <span>CRES</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Step</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span>15425181</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Merchant</span>
                          <span className="punctuation">{">"}</span>
                          <span>IA00007A</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Merchant</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span>EBDCFB9EA0524A688A23779792A644F7</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PAN</span>
                          <span className="punctuation">{">"}</span>
                          <span>4125706004391888</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PAN</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PAN2</span>
                          <span className="punctuation">{">"}</span>
                          <span>4125706004391888</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PAN2</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ExpDate</span>
                          <span className="punctuation">{">"}</span>
                          <span>2211</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ExpDate</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CardHolderName</span>
                          <span className="punctuation">{">"}</span>
                          <span>Jhon Doe</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CardHolderName</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CVV2</span>
                          <span className="punctuation">{">"}</span>
                          <span>814</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CVV2</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CRes</span>
                          <span className="punctuation">{">"}</span>
                          <span>eyJ0aHJlZURTU2VydmVyVHJhbnNJRCI6IjdkZjI5ZjhiLTI1MDUtNDZkNC1iM2MwLWZmZTg4ZT
hhYjAxNSIsImFjc1RyYW5zSUQiOiJjYzA0ZjI0ZS1hZjViLTRiNjYtYjk3NC1jZDg2MjRmYTBkOWUiLCJtZXNz
YWdlVHlwZSI6IkNSZXMiLCJtZXNzYWdlVmVyc2lvbiI6IjIuMS4wIiwidHJhbnNTdGF0dXMiOiJZIn0</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CRes</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Request</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                      </code> 
                    </pre>
                  </div>
                </div>
              </>
            ) : (
              <>
             
                <div className="code-ceontent">
                  <div className="code-body">
                      <pre ref={copyBodyRef3} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span>Process3DSAuth</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Result</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">XMLOut</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Message
                          date="21/09/2021
                          11:54:58</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Language</span>
                          <span className="punctuation">{">"}</span>
                          <span>GE</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Language</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ResponseCode</span>
                          <span className="punctuation">{">"}</span>
                          <span>001</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ResponseCode</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Version</span>
                          <span className="punctuation">{">"}</span>
                          <span>1.0</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Version</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Currency</span>
                          <span className="punctuation">{">"}</span>
                          <span>981</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Currency</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PAN</span>
                          <span className="punctuation">{">"}</span>
                          <span>412570XXXXXX1888</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PAN</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">SessionId</span>
                          <span className="punctuation">{">"}</span>
                          <span>EBDCFB9EA0524A688A23779792A644F7</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">SessionId</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">TotalAmountScr</span>
                          <span className="punctuation">{">"}</span>
                          <span>0.01</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TotalAmountScr</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CurrencyISOAlpha</span>
                          <span className="punctuation">{">"}</span>
                          <span>GEL</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CurrencyISOAlpha</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">TranDateTime</span>
                          <span className="punctuation">{">"}</span>
                          <span>21/09/2021 11:54:58</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TranDateTime</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ThreeDSVerification</span>
                          <span className="punctuation">{">"}</span>
                          <span>Y</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ThreeDSVerification</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ApprovalCodeScr</span>
                          <span className="punctuation">{">"}</span>
                          <span>703528</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ApprovalCodeScr</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">AcqFeeScr</span>
                          <span className="punctuation">{">"}</span>
                          <span>0.00</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">AcqFeeScr</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CurrencyScr</span>
                          <span className="punctuation">{">"}</span>
                          <span>Lari</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CurrencyScr</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">AuthorizationResponseCode</span>
                          <span className="punctuation">{">"}</span>
                          <span>01</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">AuthorizationResponseCode</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">OrderDescription</span>
                          <span className="punctuation">{">"}</span>
                          <span>Descr 123124</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">OrderDescription</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PurchaseAmountScr</span>
                          <span className="punctuation">{">"}</span>
                          <span>0.01</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PurchaseAmountScr</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ThreeDSVerificaion</span>
                          <span className="punctuation">{">"}</span>
                          <span>Y</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ThreeDSVerificaion</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">TransactionType</span>
                          <span className="punctuation">{">"}</span>
                          <span>Purchase</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TransactionType</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">MerchantTranID</span>
                          <span className="punctuation">{">"}</span>
                          <span>4c246316-811c-4571-a904-0e253d3e3a19</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">MerchantTranID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">OrderStatusScr</span>
                          <span className="punctuation">{">"}</span>
                          <span>დადასტურებულია</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">OrderStatusScr</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">TotalAmount</span>
                          <span className="punctuation">{">"}</span>
                          <span>1</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TotalAmount</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">RezultOperation</span>
                          <span className="punctuation">{">"}</span>
                          <span>შედეგი</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">RezultOperation</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ThreeDSVars</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">          </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PrefixParam</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PurchaseIfNotEnrolled</span>
                          <span className="punctuation">{">"}</span>
                          <span>true</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PurchaseIfNotEnrolled</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">TypeCard</span>
                          <span className="punctuation">{">"}</span>
                          <span>3DS1_TERA</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TypeCard</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">          </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PrefixParam</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">          </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">AnswerVars</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">eci</span>
                          <span className="punctuation">{">"}</span>
                          <span>05</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">eci</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ThreeDSVersion</span>
                          <span className="punctuation">{">"}</span>
                          <span>2</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ThreeDSVersion</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CalculatedCAVV</span>
                          <span className="punctuation">{">"}</span>
                          <span>4c246316811c4571a9040e253d3e3a19000000000002010803009600000000086600960000000000</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CalculatedCAVV</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ThreeDSVerification</span>
                          <span className="punctuation">{">"}</span>
                          <span>Y</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ThreeDSVerification</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ThreeDSVerificaion</span>
                          <span className="punctuation">{">"}</span>
                          <span>Y</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ThreeDSVerificaion</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">xid</span>
                          <span className="punctuation">{">"}</span>
                          <span>4c246316-811c-4571-a904-0e253d3e3a19</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">xid</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CAVV</span>
                          <span className="punctuation">{">"}</span>
                          <span>AAIBCAMAlgAAAAAIZgCWAAAAAAA=</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CAVV</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">HexCAVV</span>
                          <span className="punctuation">{">"}</span>
                          <span>4c246316811c4571a9040e25
3d3e3a19000000000002010803009600000000086600960000000000</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">HexCAVV</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">          </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">AnswerVars</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ThreeDSVars</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ShopName</span>
                          <span className="punctuation">{">"}</span>
                          <span>Demo Site</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ShopName</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span>EBDCFB9EA0524A688A23779792A644F7</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span>15425181</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ApprovalCode</span>
                          <span className="punctuation">{">"}</span>
                          <span>703528A</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ApprovalCode</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">FeeScr</span>
                          <span className="punctuation">{">"}</span>
                          <span>0.00</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">FeeScr</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PAN2</span>
                          <span className="punctuation">{">"}</span>
                          <span>412570XXXXXX1888</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PAN2</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">OrderStatus</span>
                          <span className="punctuation">{">"}</span>
                          <span>APPROVED</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">OrderStatus</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Brand</span>
                          <span className="punctuation">{">"}</span>
                          <span>3DS1_TERA</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Brand</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">RRN</span>
                          <span className="punctuation">{">"}</span>
                          <span>000008660097</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">RRN</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">PurchaseAmount</span>
                          <span className="punctuation">{">"}</span>
                          <span>1</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">PurchaseAmount</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">TranId</span>
                          <span className="punctuation">{">"}</span>
                          <span>8660097</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TranId</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Message</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">XMLOut</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Result</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Status</span>
                          <span className="punctuation">{">"}</span>
                          <span>00</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Status</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">AuthenticationValue</span>
                          <span className="punctuation">{">"}</span>
                          <span>AAIBCAMAlgAAAAAIZgCWAAAAAAA=</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">AuthenticationValue</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ECI</span>
                          <span className="punctuation">{">"}</span>
                          <span>05=</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ECI</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                      </code> 
                    </pre>
                  </div>
                </div>
               

                <div className="other-hint">
                  <p className="pb-16">
                   Merchant informs the customer of the operation execution result.
                  </p>
                  
                </div>
              </>
            )}{" "}
          </div>
        </div>


      </div>
    </>
  );
}
